<template>
    <div class="pretty p-svg">
        <input :type="type" :name="name" value="" id="" ref="input" :checked="isChecked" @click="setValue">
        <div class="state p-warning-o">
            <svg class="svg svg-icon" xmlns="http://www.w3.org/2000/svg" width="12.838" height="10.26" viewBox="0 0 12.838 10.26">
                <path id="Pfad_325" data-name="Pfad 325" d="M1590.747,2423.3l-5.292,5.957-3.307-3.309" transform="translate(-1580.027 -2421.186)" fill="none" stroke="#bc6c25" stroke-linecap="round" stroke-miterlimit="10" stroke-width="3"/>
            </svg>

            <label><slot></slot></label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'checkValue': {
            type: null,
            default: true
        },
        'connected': {
            type: null,
            default: false
        },
        'uncheckValue': {
            type: null,
            default: false
        },
        'value': {
            type: null,
            default: false
        },
        'name': String,
        'checked': Boolean,
        'type': {
            type: String,
            default: 'checkbox'
        }
    },
    data() {
        return {

        };
    },
    computed: {
        isChecked() {
            if(this.checked) {
                return this.checked;
            }

            return this.checkValue == this.value;
        }
    },

    methods: {
        setValue() {
            let val = this.checkValue;

            if(this.type === 'checkbox' && !this.$refs.input.checked) {
                val = this.uncheckValue;
            }

            this.$emit('input', val);
            this.$emit('change', val);
        }
    },
};
</script>

<style lang="scss">
/* REQUIRED */
@import 'pretty-checkbox/src/scss/variables.scss';
$pretty--color-warning: #bc6c25;

@import 'pretty-checkbox/src/scss/core.scss';

/* OPTIONALS */
@import 'pretty-checkbox/src/scss/elements/default/fill.scss';
@import 'pretty-checkbox/src/scss/elements/default/thick.scss';
@import 'pretty-checkbox/src/scss/elements/font-icon/general.scss';

@import 'pretty-checkbox/src/scss/elements/svg/general.scss';

@import 'pretty-checkbox/src/scss/elements/image/general.scss';

@import 'pretty-checkbox/src/scss/elements/switch/general.scss';
@import 'pretty-checkbox/src/scss/elements/switch/fill.scss';
@import 'pretty-checkbox/src/scss/elements/switch/slim.scss';

@import 'pretty-checkbox/src/scss/extras/toggle.scss';
@import 'pretty-checkbox/src/scss/extras/plain.scss';
@import 'pretty-checkbox/src/scss/extras/round.scss';
@import 'pretty-checkbox/src/scss/extras/curve.scss';
@import 'pretty-checkbox/src/scss/extras/animation.scss';
@import 'pretty-checkbox/src/scss/extras/disabled.scss';
@import 'pretty-checkbox/src/scss/extras/locked.scss';
@import 'pretty-checkbox/src/scss/extras/colors.scss';
@import 'pretty-checkbox/src/scss/extras/print.scss';

@import 'pretty-checkbox/src/scss/states/hover.scss';
@import 'pretty-checkbox/src/scss/states/focus.scss';
@import 'pretty-checkbox/src/scss/states/indeterminate.scss';

.pretty {
    margin-right: 0;
}
</style>
